// First-touch attribution + per-tab visitor id. Deliberately dependency-free:
// App.js calls captureAttribution() on boot, so anything imported here lands in
// the main bundle on every page (booking.js — axios, the estimator engine — is
// only loaded with the pages that need it and re-exports these helpers).
import { devWarn } from "@/lib/logger";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const ATTR_KEY = "idb:attribution";
const SESSION_KEY = "idb:session";

const storage = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const getSessionId = () => {
  const s = storage();
  let id = s?.getItem(SESSION_KEY);
  if (!id) {
    id = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `s-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
    s?.setItem(SESSION_KEY, id);
  }
  return id;
};

/** Record first-touch referrer + UTM for this tab (call once on app boot; harmless to repeat). */
export const captureAttribution = () => {
  if (typeof window === "undefined") return null;
  const s = storage();
  const existing = s?.getItem(ATTR_KEY);
  if (existing) {
    try {
      return JSON.parse(existing);
    } catch (err) {
      devWarn("[attribution] stored attribution unreadable, rewriting:", err?.message || err); // rewritten below
    }
  }
  const params = new URLSearchParams(window.location.search);
  const attr = { referrer: "", landing_path: window.location.pathname };
  for (const k of UTM_KEYS) attr[k] = (params.get(k) || "").slice(0, 120);
  try {
    const ref = document.referrer ? new URL(document.referrer) : null;
    if (ref && ref.host !== window.location.host) attr.referrer = document.referrer.slice(0, 500);
  } catch (err) {
    devWarn("[attribution] malformed document.referrer ignored:", err?.message || err);
  }
  s?.setItem(ATTR_KEY, JSON.stringify(attr));
  return attr;
};
